import { Link } from "gatsby"
import React from "react"

export const PagesHits = ({ hits, last_entry_ref, close_search_modal }) => {
  const breadcrumb_colormapping = {
    "Aufträge finden": "ausschreibungsdienste",
    "Aufträge vergeben": "evergabe",
    "B_I umweltbau": "umweltbau",
    "B_I baumagazin": "baumagazin",
    "B_I galabau": "galabau",
  }

  return (
    <div className="columns is-multiline">
      {hits?.map(
        ({ title, objectID, breadcrumbs, _snippetResult, path }, i) => (
          <React.Fragment key={objectID}>
            <Link
              to={path}
              onClick={close_search_modal}
              className="column is-6 mb-6"
              ref={
                i === Math.floor((hits.length / 20 - 1) * 20) - 1
                  ? last_entry_ref
                  : null
              }
            >
              <div className="columns is-vcentered is-variable is-mobile is-1 is-clipped">
                <div className="column is-narrow">
                  <span
                    className={`has-background-${
                      breadcrumb_colormapping[breadcrumbs[0]] || "sonnengelb"
                    }`}
                    style={{
                      height: "7px",
                      width: "7px",
                      borderRadius: "50%",
                      display: "inline-block",
                    }}
                  ></span>
                </div>
                <div className="column has-text-white is-narrow">
                  {breadcrumbs?.[1] || breadcrumbs?.[0]}
                </div>
                {!!breadcrumbs?.[2] && (
                  <React.Fragment>
                    <div className="column is-narrow has-text-white ">/</div>
                    <div className="column is-narrow has-text-white ">
                      {breadcrumbs?.[2]}
                    </div>
                  </React.Fragment>
                )}
              </div>
              <div className="pr-5">
                <p className="has-text-white title is-5">{title}</p>
                <p
                  className="has-text-white internal-search-snippet"
                  dangerouslySetInnerHTML={{
                    __html: _snippetResult.content.value,
                  }}
                ></p>
              </div>
            </Link>
            <hr className="is-hidden-desktop mx-6" />
          </React.Fragment>
        )
      )}
    </div>
  )
}
